import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

export function ScrollToTopOnNav() {
  const { pathname, key } = useLocation();

  useLayoutEffect(() => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    requestAnimationFrame(() => {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    });
  }, [pathname, key]);

  return null;
}
